/**
 * @author Batch Themes Ltd.
 * @description Mousetrap helpers to control layout settings with the keyboard
 */
import React, { Component } from 'react' // eslint-disable-line no-unused-vars
import { connect } from 'react-redux'
import { setConfig } from '../actions/config'
import Mousetrap from 'mousetrap'
import { indexOf } from 'lodash'

class Shortcuts extends Component {
  constructor () {
    super()
    this.setBackground = this.setBackground.bind(this)
    this.setNavbar = this.setNavbar.bind(this)
    this.setLeftSidebar = this.setLeftSidebar.bind(this)
    this.setLogo = this.setLogo.bind(this)
    this.toggleLayout = this.toggleLayout.bind(this)
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this)
    const self = this
    Mousetrap.bind('ctrl+1', () => {
      self.setBackground()
    })
    Mousetrap.bind('ctrl+2', () => {
      self.setNavbar()
    })
    Mousetrap.bind('ctrl+3', () => {
      self.setLeftSidebar()
    })
    Mousetrap.bind('ctrl+4', () => {
      self.setLogo()
    })
    Mousetrap.bind('ctrl+4', () => {
      self.setLogo()
    })
    Mousetrap.bind('ctrl+5', () => {
      self.toggleLayout()
    })
    Mousetrap.bind('ctrl+6', () => {
      self.toggleRightSidebar()
    })
  }

  toggleLayout () {
    this.props.setConfig('collapsed', !this.props.config.collapsed)
  }

  toggleRightSidebar () {
    this.props.setConfig('rightSidebar', !this.props.config.rightSidebar)
  }

  setBackground () {
    const backgroundColors = Object.keys(this.props.backgroundColors)
    const index = indexOf(backgroundColors, this.props.config.background)
    const nextColor = backgroundColors[index + 1]
      ? backgroundColors[index + 1]
      : backgroundColors[0]
    this.props.setConfig('background', nextColor)
  }

  setNavbar () {
    const backgroundColors = Object.keys(this.props.backgroundColors)
    const index = indexOf(backgroundColors, this.props.config.navbar)
    const nextColor = backgroundColors[index + 1]
      ? backgroundColors[index + 1]
      : backgroundColors[0]
    this.props.setConfig('navbar', nextColor)
  }

  setLeftSidebar () {
    const backgroundColors = Object.keys(this.props.backgroundColors)
    const index = indexOf(backgroundColors, this.props.config.leftSidebar)
    const nextColor = backgroundColors[index + 1]
      ? backgroundColors[index + 1]
      : backgroundColors[0]
    this.props.setConfig('leftSidebar', nextColor)
  }

  setLogo () {
    const colors = Object.keys(this.props.colors)
    const index = indexOf(colors, this.props.config.logo)
    const nextColor = colors[index + 1] ? colors[index + 1] : colors[0]
    this.props.setConfig('logo', nextColor)
  }

  render () {
    return <div />
  }
}
const mapStateToProps = ({ config, colors, backgroundColors }, ownProps) => ({ config, colors, backgroundColors })
const mapDispatchToProps = dispatch => ({
  setConfig: (key, value) => dispatch(setConfig(key, value))
})
export default connect(mapStateToProps, mapDispatchToProps)(Shortcuts)



// WEBPACK FOOTER //
// ./src/helpers/Shortcuts.js